import request from '@/utils/request'

const getById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/learning-card/${id}`,
    method: 'get'
  })
}

const getAvailableLearningCards = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/learning-card/available-cards`,
    method: 'get'
  })
}

const getLearningCardList = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/learning-card`,
    method: 'get'
  })
}

const getLearningCardPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/learning-card/page-list`,
    method: 'get',
    params: query
  })
}

export default {
  getById,
  getAvailableLearningCards,
  getLearningCardList,
  getLearningCardPageList
}
